//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import initializeAFSGridFilter from 'redux/modules/interferenceAnalysis/thunks/initializeAFSGridFilter'
import { initializeEarthStationResultsForm } from 'components/InterferenceAnalysis/EarthStationResults/helpers'

// bandId is the new bandId to assign
const handleEarthStationBandChange = bandId => async dispatch => {
  // sets the band id and analysisTypeId but reverts all the other values
  await dispatch(initializeAFSGridFilter({
    bandId,
  }))

  return dispatch(initializeEarthStationResultsForm())
}

export default handleEarthStationBandChange
